import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

type FooterLink = { to: string; label: string; badge?: string };
type FooterColumn = { title: string; links: FooterLink[] };

const COLUMNS: FooterColumn[] = [
  {
    title: "Product",
    links: [
      { to: "/how-it-works", label: "How it works" },
      { to: "/research", label: "Research" },
    ],
  },
  {
    title: "Info",
    links: [
      { to: "/", label: "Home" },
      { to: "/shopping", label: "Shop" },
      { to: "/contact", label: "Contact" },
      { to: "/privacy", label: "Privacy" },
    ],
  },
  {
    title: "Account",
    links: [
      { to: "/login", label: "Sign in" },
      { to: "/signup", label: "Create account" },
    ],
  },
];

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer" aria-label="Site footer">
      <div className="site-footer-inner">
        <div className="site-footer-grid">
          <div className="site-footer-brand">
            <Link to="/" className="site-footer-logo" aria-label="mRehab home">
              <img
                src="/mrehabIcon.png"
                alt=""
                width={40}
                height={40}
                className="site-footer-logo-img"
              />
              <span className="site-footer-logo-text">mRehab</span>
            </Link>
            <p className="site-footer-tagline">
              Upper-limb practice at home after stroke. Smartphone feedback,
              optional printed tools, and dashboards for patients and clinicians.
            </p>
          </div>

          <nav className="site-footer-nav" aria-label="Footer navigation">
            {COLUMNS.map((col) => (
              <div className="site-footer-col" key={col.title}>
                <p className="ui-section-label">{col.title}</p>
                <ul className="site-footer-links">
                  {col.links.map((link) => (
                    <li className="site-footer-row" key={link.to}>
                      <Link to={link.to} className="site-footer-link">
                        {link.label}
                      </Link>
                      {link.badge && (
                        <span className="ui-badge ui-badge--neutral">{link.badge}</span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </nav>
        </div>

        <div className="site-footer-bottom">
          <p className="site-footer-fine-print">
            &copy; {year} mRehab. All rights reserved.
          </p>
          <a href="mailto:support@mrehab.agency" className="ui-link site-footer-mail">
            support@mrehab.agency
          </a>
        </div>
      </div>
    </footer>
  );
}
